// extracted by mini-css-extract-plugin
module.exports = {"button":"mobileNavbarOptions_button__DOMiY","hamburgerColor":"mobileNavbarOptions_hamburgerColor__I4mr_"};